module.exports = __webpack_public_path__ + "static/media/user-linkedIn.567e8444.svg";